import { LegalCaseState } from '@law-connect/types';

export const isVerifyDisabled = (prematterState: LegalCaseState) => {
  return (
    prematterState === LegalCaseState.VerificationPending ||
    prematterState === LegalCaseState.Verified
  );
};